import { siteMetadata } from '../../gatsby-config'
const { mapboxToken } = siteMetadata
export default [
  {
    //https://github.com/mapbox/mapbox-gl-directions/blob/master/src/directions.js
    language: 'de-DE',
    accessToken: mapboxToken,
    steps: true,
    exclude: '',
    unit: 'metric',
    alternatives: true,
    interactive: false,
    controls: {
      inputs: true,
      instructions: true,
      profileSwitcher: true,
    },
    profile: 'mapbox/driving-traffic',
    flyTo: false,
    // custom
    origin: [8.7255307, 45.6300625],
    destination: [12.138428, 46.537534],
    pois: [[12.213150,46.143900]],
  },
]
